import React from "react";
import { Panel, TextInput, ToggleInput } from "../input";
import { isUpdatedFromDefault } from "../utils";

function Visibility({ block, actions, ...props }) {
  const {
    id,
    props: { hideDesktop, hideTablet, hideMobile },
    dom,
  } = block;

  const { setProp } = actions;

  return (
    <>
      <Panel
        isUpdated={isUpdatedFromDefault([
          { key: hideDesktop },
          { key: hideTablet },
          { key: hideMobile },
        ])}
        id={`block-setting-${id}-visibility`}
        title={"Visibility"}
        initialOpen={false}
      >
        <ToggleInput
          value={hideDesktop}
          onChange={(val) => {
            setProp((props) => {
              props.hideDesktop = val;
            });
          }}
          label={"Hide On Desktop"}
        />
        <ToggleInput
          value={hideTablet}
          onChange={(val) => {
            setProp((props) => {
              props.hideTablet = val;
            });
          }}
          label={"Hide On Tablet"}
        />
        <ToggleInput
          value={hideMobile}
          onChange={(val) => {
            setProp((props) => {
              props.hideMobile = val;
            });
          }}
          label={"Hide On Mobile"}
        />
      </Panel>
    </>
  );
}

function transformProps(props, supportProps) {
  supportProps = {
    ...supportProps,
    className: {
      ...(supportProps.className ? supportProps.className : {}),
      "desktop-hidden": props.hideDesktop,
      "tablet-hidden": props.hideTablet,
      "mobile-hidden": props.hideMobile,
    },
  };
  return supportProps;
}

const supportSchema = {
  id: "grigora/visibility",
  name: "Visibility",
  component: Visibility,
  transformProps: transformProps,
};

export default supportSchema;
